import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-link',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatTooltipModule],
  templateUrl: './sidebar-link.component.html',
  styleUrl: './sidebar-link.component.css',
})
export class SidebarLinkComponent {
  constructor(private router: Router) {}

  ngDoCheck() {
    // The organisation root has no page of its own; land on the dashboard.
    if (this.router.url == '/organization') {
      this.router.navigate(['organization', 'dashboard']);
    }
  }

  @Input() iconName: string = '';
  @Input() title: string = '';
  @Input() link: string = '';
  @Input() isCollapsed: boolean = false;
  /** A small count after the label (a dot on the collapsed rail); 0 hides it. */
  @Input() badge: number = 0;
  @Input() badgeLabel: string = '';
  /**
   * The rail draws the active page's pill behind its list and slides it
   * between links; a link on it only inverts its ink. Links outside that
   * list paint their own pill.
   */
  @Input() onPill: boolean = false;

  get tooltip(): string {
    if (this.isCollapsed) {
      return this.badge > 0 && this.badgeLabel ? `${this.title} · ${this.badgeLabel}` : this.title;
    }
    return this.badge > 0 ? this.badgeLabel : '';
  }
}
